import { memo } from "react";
import PropTypes from "prop-types";
import { equals } from "ramda";
import { IconButton } from "@base-ui";
import Select from "@interdependence-ui/select/Select";
import { PaginationHolder } from "./pagination.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Pagination = /*#__PURE__*/memo(function (props) {
  var id = props.id,
    label = props.label,
    pages = props.pages,
    selected = props.selected,
    updateSelected = props.updateSelected,
    style = props.style,
    className = props.className;
  var canBePaginated = pages.length > 1;
  var options = pages.map(function (page, idx) {
    return {
      id: "".concat(id, "-page-").concat(idx),
      label: idx + 1
    };
  });
  var pageSelection = canBePaginated && /*#__PURE__*/_jsx(Select, {
    id: "".concat(id, "-page-select"),
    label: "V\xE4lj sida",
    _selected: selected,
    options: options,
    onChange: updateSelected,
    hideLabel: true,
    selectedPrefix: "Sida: ",
    style: {
      width: "140px"
    }
  });
  var previous = /*#__PURE__*/_jsx(IconButton, {
    id: "".concat(id, "-previous-page"),
    disabled: selected === 0,
    label: "F\xF6reg\xE5ende sida",
    style: {
      width: "fit-content",
      padding: "0 15px"
    },
    icon: "expandLeft",
    onClick: function onClick() {
      return updateSelected(selected - 1);
    }
  }, "previous");
  var next = /*#__PURE__*/_jsx(IconButton, {
    id: "".concat(id, "-next-page"),
    disabled: selected === pages.length - 1,
    label: "N\xE4sta sida",
    style: {
      width: "fit-content",
      padding: "0 15px"
    },
    icon: "expandRight",
    onClick: function onClick() {
      return updateSelected(selected + 1);
    }
  }, "next");
  return /*#__PURE__*/_jsxs(PaginationHolder, {
    className: className,
    style: style,
    "aria-label": label,
    children: [canBePaginated && previous, pageSelection, canBePaginated && next]
  });
}, function (prev, curr) {
  return equals(prev.pages, curr.pages) && equals(prev.selected, curr.selected);
});
Pagination.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  pages: PropTypes.array.isRequired,
  selected: PropTypes.number.isRequired,
  updateSelected: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};
export default Pagination;